import Vue from 'vue'

export default {
	state: {
		projects: [],//projects for company
		projectsAll: [],//projects for all companies
		allProjects: [
		{
			name: 'Marketing & Retail',
			cost: 7000,
			effect: 'Sales growth'
		},
		{
			name: 'Advertising & Promotion',
			cost: 4500,
			effect: 'Awareness increase'
		},
		{
			name: 'Production & Productivity',
			cost: 3800,
			effect: 'Unit cost reduction'
		},
		{
		
			name: 'R&D management',
			cost: 3500,
			effect: 'R&D project time reduction'
		}]
	},
	mutations: {
		loadProjects (state, payload) {
			state.projects = payload
		},
		loadProjectsAll (state, payload) {
			state.projectsAll = payload
		},
		addProject (state, payload) { 
			const index = state.projects.length
			Vue.set(state.projects, index, payload)  
		},
		deleteProject (state, payload) {
			state.projects = state.projects.filter(project => project.id !== payload) 
		}
	},
	actions: {
		async fetchAllProjects ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)
			const resArr = []
			
			let gameId = 'game'+ payload.gameId
			let round = 'round'+ payload.round

			try {
				const projects = await Vue.$db.collection(gameId).doc(round).collection('consultingProjects')
				.get()

				if (projects) {
					
					projects.forEach(doc => {
						const project = doc.data()
						resArr.push({
							id: doc.id,
							name: project.name,
							cost: project.cost,
							company: project.company
						})
					})
					commit('loadProjectsAll', resArr)
				}
				//no channels
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async fetchProjects ({commit, getters}) {
			commit('clearError')
			commit('setLoading', true)
			const resArr = []
			
			let gameId = 'game'+ getters.gameId
			let round = 'round'+ getters.currentRound
			let company = getters.company

			try {
				const projects = await Vue.$db.collection(gameId).doc(round).collection('consultingProjects')
				.where("company", "==", company)
				.get()

				if (projects) {
					
					projects.forEach(doc => {
						const project = doc.data()
						resArr.push({
							id: doc.id,
							name: project.name,
							cost: project.cost
						})
					})
					commit('loadProjects', resArr)
				}
				//no channels
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async addProject ({commit, getters}, payload) {
			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round

			const id = payload.project.id
			
			try {
				if (!id) {
					const projRef = await Vue.$db.collection(gameId).doc(round).collection('consultingProjects')
					.add(payload.project)
					
					payload.project.id = projRef.id
				}
				else {
					delete payload.project.id
					
					await Vue.$db.collection(gameId).doc(round).collection('consultingProjects')
					.doc(id)
					.set(payload.project)
					
					payload.project.id = id
				}
				
				if (getters.currentRound == payload.round) {
					commit('addProject', payload.project)
				}
				commit('setLoading', false)
				
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async deleteProject ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			const id = payload.id
			
			try {
				await Vue.$db.collection(gameId).doc(round).collection('consultingProjects').doc(id).delete()

				commit('setLoading', false)
				commit('deleteProject', id)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		}
	},
	getters: {
		projects (state) {
			return state.projects
		},
		allProjects (state) {
			return state.allProjects
		},
		projectsAll (state) {
			return state.projectsAll
		}
	}
}